import styled from 'styled-components';

import { StyledClickableContainer as StyledContainer } from './external-incentive-card.styled.default';

export * from './external-incentive-card.styled.default';

export const StyledClickableContainer = styled(StyledContainer)`
  background-color: ${Styles.color.white};
`;
